import { schema } from 'normalizr';

export const bankRate = new schema.Entity(
  'banksRates',
  {},
  {
    idAttribute: item => parseInt(item.companyId, 10),
  }
);

export const convertorBanksRates = [bankRate];
